import { NgModule } from '@angular/core';
import { TalentStatutComponent } from './talent-status.component';

@NgModule({
    declarations: [ TalentStatutComponent ],
    exports: [ TalentStatutComponent ]
})
export class TalentsModule {
}
